import { Component, OnInit, Input } from "@angular/core";
import { MDBModalRef, ToastService } from "ng-uikit-pro-standard";
import { ProductType } from "src/app/core/product/enums";
import { AppService } from "src/app/core/app/app.service";
import { Router } from "@angular/router";
import { Pass } from "src/app/core/product/product.factory";
import { MatDialogRef } from "@angular/material/dialog";
import { DateDetailsPopupComponent } from "../../popups";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "ll-pass-list",
  templateUrl: "./pass-list.component.html",
  styleUrls: ["./pass-list.component.scss"]
})
export class PassListComponent implements OnInit {
  @Input() events: Pass[];
  @Input() dialogRef: MatDialogRef<DateDetailsPopupComponent>;
  public columns = ["rank", "name", "price", "max", "sold", "visibility"];
  public passes: Pass[];
  public orderChanged: boolean;
  public isLoading: boolean;
  constructor(private app: AppService, private router: Router, public httpClient: HttpClient, public toast: ToastService) {}

  ngOnInit(): void {
    this.orderChanged = false;
    this.isLoading = true;
    this.loadPasses();
  }
  async loadPasses() {
    this.passes = this.getPasses();
    this.isLoading = false;
  }

  getPasses(): Pass[] {
    return this.events.sort((a, b) => a.event.rank - b.event.rank);
  }

  drop(event: CdkDragDrop<Pass[]>) {
    moveItemInArray(this.passes, event.previousIndex, event.currentIndex);
    this.orderChanged = true;
  }
  async save() {
    const userJWT = await this.app.state.getUserJWT();

    this.isLoading = true;
    const updateRankPromiseArray = [];
    for (var i = 0; i < this.passes.length; i++) {
      updateRankPromiseArray.push(this.passes[i].event.updateRank(
        this.httpClient, 
        userJWT, 
        i,
      ));
    }

    await Promise.all(updateRankPromiseArray)
        .catch((error) => {
            this.toast.error("Error updating event ranks.", "Error", {opacity: 1});
            throw(error);
        })

    this.dialogRef.close();
  }

  isVisible(pass: Pass): boolean {
    return pass.event.isVisible(pass.product);
  }

  get isAdmin(): string {
    return this.router.url.includes("admin") ? "/admin" : "";
  }
  edit(pass: Pass, route: string) {
    this.dialogRef.close();
    if (pass.product.productType == ProductType.Bundle)
      this.app.isBundleForm = true;
    this.app.editProductBuilder(pass.product);
    this.router.navigateByUrl(`${this.isAdmin}/venue/passes/${route}`);
  }
}
